import math from '@/common/math'
import request from '@/common/request'
export default {
	SCALE: {
		num: 0,
		weight: 3,
		price: 2,
		money: 2,
		exPrice: 4,
		taxRate: 2
	},
	WRAPPER: {
		labelCol: {
			span: 8
		},
		wrapperCol: {
			span: 16
		}
	},
	COL: {
		span: 4
	},
	RULE_MODEL: {
		projectId: {
			title: "项目",
			field: "projectId",
			type: "v-selectpage",
			props: {
				data: '/project/mesProject',
				keyField: "projectId",
				showField: "projectName",
				searchField: "projectName",
				title: "请选择项目",
			},
			master: true
		},
		warehouseId: {
			type: 'v-selectpage',
			field: 'warehouse_id',
			title: '仓库',
			master: true,
			props: {
				data: '/warehouse/baseWarehouse',
				keyField: "warehouseId",
				showField: "warehouseName",
				searchField: "warehouseName",
				title: "请选择仓库",
				placeholder: "仓库",
			},
		},
		productName: {
			type: 'GAutoComplete',
			field: 'product_name',
			title: '品名',
			master: true,
			props: {
				url: "/goods/baseGoods/productName",
				keyField: "productName",
				show: "productName",
			},
		},
		goodsBrand: {
			type: 'GAutoComplete',
			field: 'goodsBrand',
			title: '产地',
			master: true,
			props: {
				url: "/goods/baseGoods/goodsBrand",
				keyField: "goodsBrand",
				show: "goodsBrand",
			},
		},
		goodsMaterial: {
			type: 'GAutoComplete',
			field: 'goodsMaterial',
			title: '材质',
			master: true,
			props: {
				url: "/goods/baseGoods/goodsMaterial",
				keyField: "goodsMaterial",
				show: "goodsMaterial",
			},
		},
		goodsSpec: {
			type: 'GAutoComplete',
			field: 'goodsSpec',
			title: '规格',
			master: true,
			props: {
				url: "/goods/baseGoods/goodsSpec",
				keyField: "goodsSpec",
				show: "goodsSpec",
			},
		},
		supplierId: {
			type: 'v-selectpage',
			field: 'supplier_id',
			title: '供应商',
			master: true,
			props: {
				data: '/company/baseCompany',
				keyField: "companyId",
				showField: "companyName",
				searchField: "companyName",
				title: "请选择供应商",
			},
			wrap: {
				labelCol: {
					span: 2
				},
				wrapperCol: {
					span: 4
				}
			}
		},
		companyId: {
			type: 'GSelect',
			field: 'supplier_id',
			title: '结算单位',
			master: true,
			props: {
				url: '/company/baseCompany',
				keyField: 'companyId',
				show: 'companyName',
				search: 'companyName',
				queryParam: {
					companyName: 'companyName'
				},
				showSearch: true
			},
			wrap: {
				labelCol: {
					span: 2
				},
				wrapperCol: {
					span: 4
				}
			}
		},
		employeeId: {
			type: 'v-selectpage',
			field: 'employeeId',
			title: '业务员',
			props: {
				data: '/sys/user/list',
				keyField: "id",
				showField: "realName",
				searchField: "realName",
				title: "请选择业务员",
				placeholder: "请选择业务员",
			},
		}
	},
	COMPUTER_COLUMN: {
		'goodsWeight': 'goodsWeight',
		'goodsPrice': 'goodsPrice',
		'goodsExPrice': 'goodsExPrice',
		'goodsTaxRate': 'goodsTaxRate',
		'goodsAmount': 'goodsAmount',
		'goodsExAmount': 'goodsExAmount',
		'goodsTaxAmount': 'goodsTaxAmount'
	},
	clone(obj, ignore) {
		let newObj = null
		if (typeof obj === 'object' && obj !== null) {
			newObj = obj instanceof Array ? [] : {};
			if (Array.isArray(obj)) {
				let beans = []
				for (let p = 0; p < obj.length; p++) {
					beans[p] = this.clone(obj[p], ignore)
				}
				newObj = beans
			} else {
				for (let i in obj) {
					// 如果该属性是忽略字段，则跳过
					if (ignore && ignore.indexOf(i) >= 0) {
						continue
					}
					newObj[i] = typeof obj[i] === 'object' ? this.clone(obj[i], ignore) : obj[i]
				}
			}
		} else {
			newObj = obj
		}
		return newObj
	},
	setEmpty(obj, ignore) {
		if (obj instanceof Object) {
			Object.keys(obj).forEach(key => {
				// 是否忽略置空
				let isIgnore = false
				if (ignore) {
					ignore.forEach(value => {
						if (value == key) {
							isIgnore = true
						}
					})
				}
				if (!isIgnore) {
					obj[key] = ''
				}
			})
		} else {
			obj = {}
		}
		return obj
	},
	// form-create 重写规则
	overwriteRule(rules) {
		// 是否查询条件标记  如果是查询条件 则有隐藏
		let queryFromFlag = false
		rules.forEach((v, i) => {
			// 如果是radio 重写规则
			if (v.type == 'radio') {
				if (v.props && v.props.type && v.props.type == 'button') {
					v.type = 'a-radio-group'
					v['children'] = []
					v.options.forEach((subItem, i) => {
						v['children'].push({
							type: 'a-radio-button',
							props: {
								value: subItem.value,
							},
							children: [
								subItem.label
							]
						})
					})
				}
			}
			if (v.master) {
				queryFromFlag = true
			}
			//不是主要查询条件 默认隐藏
			if (queryFromFlag && !v.master) {
				v.hidden = true
			}
		})
		return rules
	},
	getOption() {
		let result = {
			resetBtn: false,
			submitBtn: false,
			row: false,
			from: {
				hideRequiredMark: false,
				layout: 'inline',
				labelAlign: 'right',
				labelCol: {
					span: 4
				},
				wrapperCol: {
					span: 20
				},
				colon: undefined,
				validateOnRuleChange: true
			}
		}
		return result
	},
	/***
	 *
	 * @param data 源数据
	 * @param newData 目标数据
	 * @param attr
	 * @returns {boolean|*}
	 */
	setAttributes(data, newData, attr) {
		if (!data || data.length == 0 || !attr) {
			return false;
		}
		// 先赋空值
		Object.keys(attr).forEach(key => {
			newData[key] = ''
		})
		// 拼接值
		data.forEach(item => {
			Object.keys(attr).forEach(key => {
				newData[key] += item[attr[key]] + ','
			})
		})
		//删除多余逗号(最后一个)
		Object.keys(attr).forEach(key => {
			if (newData[key]) {
				newData[key] = newData[key].substring(0, newData[key].length - 1)
			}
		})
		return newData;
	},
	copyProperty(source, target, ignoreBlank = true, ignoreArray) {
		for (let key in source) {
			if (ignoreArray && ignoreArray.indexOf(key) >= 0) {
				continue
			}
			if (source[key] instanceof Object || source[key] instanceof Array) {
				if (!target[key]) {
					target[key] = source[key] instanceof Array ? [] : {}
				}
				this.copyProperty(source[key], target[key], ignoreBlank)
			} else {
				// 判断是否为空
				if (this.isNull(source[key])) {
					// 如果不忽略空 则赋值
					if (!ignoreBlank) {
						target[key] = source[key]
					}
				} else {
					target[key] = source[key]
				}

			}
		}
	},
	copyPropertys(source, target, keys) {
		for (let key of keys) {
			if (source[key] instanceof Object) {
				this.copyProperty(source[key], target[key])
			} else {
				target[key] = source[key]
			}
		}
	},
	isEmptyObj(obj) {
		return Object.keys(obj).length === 0;
	},
	isEmpty(obj) {
		if (this.isNull(obj)) {
			return true
		}
		if (obj instanceof Object) {
			return this.isEmptyObj(obj)
		}
		return false;
	},
	isNotEmpty(obj) {
		return !this.isEmpty(obj);
	},
	isNull(data) {
		return (data === "" || data == undefined || data == null)
	},
	isNotNull(data) {
		return !this.isNull(data)
	},
	//单价金额换算
	calculate($table, $newData, $editcolumn, $rowIndex, $computerColumn) {

		if (!$table || !$newData || !$editcolumn) {
			return false
		}
		console.log(math)
		console.log(math.plus)
		if (undefined == $computerColumn || null == $computerColumn) {
			$computerColumn = this.COMPUTER_COLUMN;
		}
		let data = {};
		console.log(1)
		let weight = $newData[$computerColumn['goodsWeight']];
		let inPrice = $newData[$computerColumn['goodsPrice']];
		let taxRate = math.plus(1, $newData[$computerColumn['goodsTaxRate']], this.SCALE.taxRate); //税率
		if (undefined == weight || null == weight || isNaN(weight)) {
			weight = 0;
		}
		if ('goodsWeight' == $editcolumn) { //重量
			data[$computerColumn['goodsAmount']] = math.times(weight, inPrice, this.SCALE.money);
			data[$computerColumn['goodsExAmount']] = math.times(weight, $newData[$computerColumn['goodsExPrice']], this
				.SCALE.money);
			data[$computerColumn['goodsTaxAmount']] = math.minus(data[$computerColumn['goodsAmount']], data[
				$computerColumn['goodsExAmount']], this.SCALE.money);

		} else if ('goodsPrice' == $editcolumn) { //含税单价
			data[$computerColumn['goodsAmount']] = math.times(weight, inPrice, this.SCALE.money);
			data[$computerColumn['goodsExPrice']] = math.divide(inPrice, taxRate, this.SCALE.exPrice);
			data[$computerColumn['goodsExAmount']] = math.times(weight, data[$computerColumn['goodsExPrice']], this
				.SCALE.money);
			data[$computerColumn['goodsTaxAmount']] = math.minus(data[$computerColumn['goodsAmount']], data[
				$computerColumn['goodsExAmount']], this.SCALE.money);

		} else if ('goodsExPrice' == $editcolumn) { //无税单价
			data[$computerColumn['goodsPrice']] = math.times($newData[$computerColumn['goodsExPrice']], taxRate, this
				.SCALE.exPrice);
			data[$computerColumn['goodsAmount']] = math.times(weight, data[$computerColumn['goodsPrice']], this.SCALE
				.money);
			data[$computerColumn['goodsExAmount']] = math.times(weight, $newData[$computerColumn['goodsExPrice']], this
				.SCALE.money);
			data[$computerColumn['goodsTaxAmount']] = math.minus(data[$computerColumn['goodsAmount']], data[
				$computerColumn['goodsExAmount']], this.SCALE.money);

		} else if ('goodsAmount' == $editcolumn) { //含税金额
			data[$computerColumn['goodsPrice']] = math.divide($newData[$computerColumn['goodsAmount']], weight, this
				.SCALE.price);
			data[$computerColumn['goodsExPrice']] = math.divide(data[$computerColumn['goodsPrice']], taxRate, this.SCALE
				.exPrice);
			data[$computerColumn['goodsExAmount']] = math.times(weight, data[$computerColumn['goodsExPrice']], this
				.SCALE.money);
			data[$computerColumn['goodsTaxAmount']] = math.minus($newData[$computerColumn['goodsAmount']], data[
				$computerColumn['goodsExAmount']], this.SCALE.money);
		} else if ('goodsTaxRate' == $editcolumn) { //税率
			data[$computerColumn['goodsExPrice']] = math.divide(inPrice, taxRate, this.SCALE.exPrice);
			data[$computerColumn['goodsExAmount']] = math.times(weight, data[$computerColumn['goodsExPrice']], this
				.SCALE.money);
			data[$computerColumn['goodsTaxAmount']] = math.minus($newData[$computerColumn['goodsAmount']], data[
				$computerColumn['goodsExAmount']], this.SCALE.money);
		}
		$table.update(data, $rowIndex);
	},
	calculateModel($newData, $editcolumn, $computerColumn) {
		if (!$newData || !$editcolumn) {
			return false
		}
		if (undefined == $computerColumn || null == $computerColumn) {
			$computerColumn = this.COMPUTER_COLUMN;
		} else {
			let computerColumn = this.COMPUTER_COLUMN;
			//拷贝属性
			this.copyProperty($computerColumn, computerColumn);
			$computerColumn = computerColumn
		}
		let data = {};
		let weight = $newData[$computerColumn['goodsWeight']];
		let inPrice = $newData[$computerColumn['goodsPrice']];
		let taxRate = math.plus(1, $newData[$computerColumn['goodsTaxRate']], this.SCALE.taxRate); //税率
		if (undefined == weight || null == weight || isNaN(weight)) {
			weight = 0;
		}
		if ('goodsWeight' == $editcolumn) { //重量
			data[$computerColumn['unitWeight']] = math.divide(weight, $newData[$computerColumn['goodsNum']], this.SCALE
				.weight);
			data[$computerColumn['goodsAmount']] = math.times(weight, inPrice, this.SCALE.money);
			data[$computerColumn['goodsExAmount']] = math.times(weight, $newData[$computerColumn['goodsExPrice']], this
				.SCALE.money);
			data[$computerColumn['goodsTaxAmount']] = math.minus(data[$computerColumn['goodsAmount']], data[
				$computerColumn['goodsExAmount']], this.SCALE.money);
		} else if (('goodsNum' == $editcolumn || 'unitWeight' == $editcolumn) && $newData[$computerColumn[
			'unitWeight']]) {
			data[$computerColumn['goodsWeight']] = math.times($newData[$computerColumn['goodsNum']], $newData[
				$computerColumn['unitWeight']], this.SCALE.weight);
			weight = data[$computerColumn['goodsWeight']]
			data[$computerColumn['goodsAmount']] = math.times(weight, inPrice, this.SCALE.money);
			data[$computerColumn['goodsExAmount']] = math.times(weight, $newData[$computerColumn['goodsExPrice']], this
				.SCALE.money);
			data[$computerColumn['goodsTaxAmount']] = math.minus(data[$computerColumn['goodsAmount']], data[
				$computerColumn['goodsExAmount']], this.SCALE.money);
		} else if ('goodsPrice' == $editcolumn) { //含税单价
			data[$computerColumn['goodsAmount']] = math.times(weight, inPrice, this.SCALE.money);
			data[$computerColumn['goodsExPrice']] = math.divide(inPrice, taxRate, this.SCALE.exPrice);
			data[$computerColumn['goodsExAmount']] = math.times(weight, data[$computerColumn['goodsExPrice']], this
				.SCALE.money);
			data[$computerColumn['goodsTaxAmount']] = math.minus(data[$computerColumn['goodsAmount']], data[
				$computerColumn['goodsExAmount']], this.SCALE.money);

		} else if ('goodsExPrice' == $editcolumn) { //无税单价
			data[$computerColumn['goodsPrice']] = math.times($newData[$computerColumn['goodsExPrice']], taxRate, this
				.SCALE.exPrice);
			data[$computerColumn['goodsAmount']] = math.times(weight, data[$computerColumn['goodsPrice']], this.SCALE
				.money);
			data[$computerColumn['goodsExAmount']] = math.times(weight, $newData[$computerColumn['goodsExPrice']], this
				.SCALE.money);
			data[$computerColumn['goodsTaxAmount']] = math.minus(data[$computerColumn['goodsAmount']], data[
				$computerColumn['goodsExAmount']], this.SCALE.money);

		} else if ('goodsAmount' == $editcolumn) { //含税金额
			data[$computerColumn['goodsPrice']] = math.divide($newData[$computerColumn['goodsAmount']], weight, this
				.SCALE.price);
			data[$computerColumn['goodsExPrice']] = math.divide(data[$computerColumn['goodsPrice']], taxRate, this.SCALE
				.exPrice);
			data[$computerColumn['goodsExAmount']] = math.times(weight, data[$computerColumn['goodsExPrice']], this
				.SCALE.money);
			data[$computerColumn['goodsTaxAmount']] = math.minus($newData[$computerColumn['goodsAmount']], data[
				$computerColumn['goodsExAmount']], this.SCALE.money);
		} else if ('goodsTaxRate' == $editcolumn) { //税率
			data[$computerColumn['goodsExPrice']] = math.divide(inPrice, taxRate, this.SCALE.exPrice);
			data[$computerColumn['goodsExAmount']] = math.times(weight, data[$computerColumn['goodsExPrice']], this
				.SCALE.money);
			data[$computerColumn['goodsTaxAmount']] = math.minus($newData[$computerColumn['goodsAmount']], data[
				$computerColumn['goodsExAmount']], this.SCALE.money);
		}
		this.copyProperty(data, $newData)
		return $newData
	},
	calculateWeight(newData,editColumn){
		let result = 0
		// 输入字段为0  直接返回
		if(!newData[editColumn]){
		  return result
		}
		return new Promise(resolve => {
		  request.get('/product/baseFormulaCompute/calculate',newData).then(res=>{
			if(res.success){
			  console.log(res.result)
			  resolve(res.result)
			}
		  }).catch(()=>{

		  })
		})
	  },
	/***
	 *  空转字符串
	 * @param data 源数据
	 * @param str 需要转的字符  默认横杠
	 * @returns {boolean|*}
	 */
	blankToStr(data, str) {
		if (!str) {
			str = '-'
		};
		if (!data) {
			return str;
		}
		return data
	},

	goodsAttributeMerge(data) {
		return this.blankToStr(data['productName']) + '/' +
			this.blankToStr(data['goodsMaterial']) + '/' +
			this.blankToStr(data['goodsSpec']) + '/' +
			this.blankToStr(data['goodsBrand'])
	},
	goodsProductAttributeMerge(data) {
		return this.blankToStr(data['productName']) + '/' + this.blankToStr(data['goodsSpec'])
	},
	getStorageSync(key) {
		let result = uni.getStorageSync(key)
		return this.toJsonOrStr(result)
	},
	setStorageSync(key, data) {
		if (data instanceof Object) {
			uni.setStorageSync(key, JSON.stringify(data))
		} else {
			uni.setStorageSync(key, data)
		}

	},
	removeStorage(key) {
		uni.removeStorageSync(key);
	},
	toJsonOrStr(str) {
		if (typeof str == 'string') {
			try {
				var obj = JSON.parse(str);
				if (typeof obj == 'object' && obj) {
					return obj;
				} else {
					return str;
				}

			} catch (e) {
				return str;
			}
		}
		return str
	},
	formatWeek(value){
		var day=value.getDay();
		var weeks=new Array("周日", "周一", "周二", "周三", "周四", "周五", "周六");
		var week=weeks[day];
		return week
	},
	formatDate(value, fmt) {
		let getDate;
		let regPos = /^\d+(\.\d+)?$/;
		if (value instanceof Date) {
			getDate = value
		} else if (regPos.test(value)) {
			// 如果是数字
			getDate = new Date(value);
		} else {
			//TODO
			value = value.trim();
			return value.substr(0, fmt.length);
		}
		let o = {
			'M+': getDate.getMonth() + 1,
			'd+': getDate.getDate(),
			'h+': getDate.getHours(),
			'm+': getDate.getMinutes(),
			's+': getDate.getSeconds(),
			'q+': Math.floor((getDate.getMonth() + 3) / 3),
			'S': getDate.getMilliseconds()
		};
		if (/(y+)/.test(fmt)) {
			fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length))
		}
		for (let k in o) {
			if (new RegExp('(' + k + ')').test(fmt)) {
				fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k])
					.length)))
			}
		}
		return fmt;
	},
	// 下划线转换驼峰
	toHump(name) {
		return name.replace(/\_(\w)/g, function(all, letter) {
			return letter.toUpperCase();
		});
	},
	// 下划线转换驼峰
	arrayToHump(datas) {
		datas.forEach(item => {
			Object.keys(item).forEach(key => {
				let newKey = this.toHump(key)
				item[newKey] = item[key]
				if (newKey != key) {
					delete item[key]
				}
			})
		})
		return datas
	},
	replaceAll(str, substr, newStr) {
		return str.replace(new RegExp(substr, 'g'), newStr);
	},
	convertRule(rules) {
		rules.forEach((v, i) => {
			// v.final  最终的 如果是最终的  就不使用字段模板
			if (this.RULE_MODEL[this.toHump(v.field)] && !v.final) {
				let item = this.clone(v);
				this.copyProperty(this.RULE_MODEL[this.toHump(v.field)], v)
				v.field = item.field
			}
		})
		let tempRule = this.clone(rules)
		return tempRule
	},
	UUID() {
		let chats = '0123456789abcdef'
		return this.randomString(32, chats)
	},
	randomString(length, chats) {
		if (!length) length = 1
		if (!chats) chats = '0123456789qwertyuioplkjhgfdsazxcvbnm'
		let str = ''
		for (let i = 0; i < length; i++) {
			let num = this.randomNumber(0, chats.length - 1)
			str += chats[num]
		}
		return str
	},
	randomNumber() {
		// 生成 最小值 到 最大值 区间的随机数
		const random = (min, max) => {
			return Math.floor(Math.random() * (max - min + 1) + min)
		}
		if (arguments.length === 1) {
			let [length] = arguments
			// 生成指定长度的随机数字，首位一定不是 0
			let nums = [...Array(length).keys()].map((i) => (i > 0 ? random(0, 9) : random(1, 9)))
			return parseInt(nums.join(''))
		} else if (arguments.length >= 2) {
			let [min, max] = arguments
			return random(min, max)
		} else {
			return Number.NaN
		}
	},
	getQueryParam(url, name) {
		if (url.indexOf("?") != -1) {
			var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
			var r = url.substr(url.indexOf("?")+1).match(reg);
			if (r != null) return unescape(r[2]);
		}
		return null;
	},

  eq(obj1,obj2){
    let i, l, leftChain, rightChain;

    function compare2Objects(x, y) {
      let p;

      // remember that NaN === NaN returns false
      // and isNaN(undefined) returns true
      if (isNaN(x) && isNaN(y) && typeof x === 'number' && typeof y === 'number') {
        return true;
      }

      // Compare primitives and functions.
      // Check if both arguments link to the same object.
      // Especially useful on the step where we compare prototypes
      if (x === y) {
        return true;
      }

      // Works in case when functions are created in constructor.
      // Comparing dates is a common scenario. Another built-ins?
      // We can even handle functions passed across iframes
      if ((typeof x === 'function' && typeof y === 'function') ||
        (x instanceof Date && y instanceof Date) ||
        (x instanceof RegExp && y instanceof RegExp) ||
        (x instanceof String && y instanceof String) ||
        (x instanceof Number && y instanceof Number)) {
        return x.toString() === y.toString();
      }

      // At last checking prototypes as good as we can
      if (!(x instanceof Object && y instanceof Object)) {
        return false;
      }

      if (x.isPrototypeOf(y) || y.isPrototypeOf(x)) {
        return false;
      }

      if (x.constructor !== y.constructor) {
        return false;
      }

      if (x.prototype !== y.prototype) {
        return false;
      }

      // Check for infinitive linking loops
      if (leftChain.indexOf(x) > -1 || rightChain.indexOf(y) > -1) {
        return false;
      }

      // Quick checking of one object being a subset of another.
      // todo: cache the structure of arguments[0] for performance
      for (p in y) {
        if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
          return false;
        } else if (typeof y[p] !== typeof x[p]) {
          return false;
        }
      }

      for (p in x) {
        if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
          return false;
        } else if (typeof y[p] !== typeof x[p]) {
          return false;
        }

        switch (typeof (x[p])) {
          case 'object':
          case 'function':

            leftChain.push(x);
            rightChain.push(y);

            if (!compare2Objects(x[p], y[p])) {
              return false;
            }

            leftChain.pop();
            rightChain.pop();
            break;

          default:
            if (x[p] !== y[p]) {
              return false;
            }
            break;
        }
      }

      return true;
    }

    if (arguments.length < 1) {
      return true; //Die silently? Don't know how to handle such case, please help...
      // throw "Need two or more arguments to compare";
    }

    for (i = 1, l = arguments.length; i < l; i++) {

      leftChain = []; //Todo: this can be cached
      rightChain = [];

      if (!compare2Objects(arguments[0], arguments[i])) {
        return false;
      }
    }
  },
  ne(obj1,obj2){
     return !this.eq(obj1,obj2)
  },
  /**
  * limitLen 默认24位半角字符长度，可修改
  **/
  formatEllipsis(str = '', limitLen = 24) {
      let 
        len = 0,
        reg = /[\x00-\xff]/, //半角字符的正则匹配
        strs = str.split(''),
        inx = strs.findIndex(s => {
          len += reg.test(s) ? 1 : 2
          if (len > limitLen) return true
        })
      return inx === -1 ? str : str.substr(0, inx) + '...'
    }
}
